import { useContext, useEffect, PropsWithChildren } from "react";
import { RootStoreContext } from "src/stores/RootStore";
import { runInAction } from "mobx";
import { Route, selectRoute } from "src/config/routes";
import { ColorStyle } from "src/utils/Colors";
import { STEP_TYPES } from "src/api/Processes";
import { ProcessProgress } from "src/components/processProgress/ProcessProgress";
import { UI } from "@wwimmo/ui";
import { useParams } from "react-router-dom";
import { SELECT_COMPONENT_TYPES } from "src/api/Select";
import { useTranslation } from "react-i18next";
import { getLang } from "src/utils/i18n";

export const Step = (props: PropsWithChildren<{ hideProcessProgress?: Boolean }>) => {
    const { t } = useTranslation();
    const { navStore, easyContactStore, uiStore } = useContext(RootStoreContext);
    const { processId, stepId, componentId } = useParams<{ processId: string; stepId: string; componentId: string }>();
    const step = easyContactStore.getStepById(processId, stepId);
    const component = easyContactStore.getSelectComponentById(componentId);

    useEffect(() => {
        easyContactStore.setStepType(step?.type!);
        easyContactStore.setShowProfileAppbarButton(false);
        if (easyContactStore.stepType === STEP_TYPES.FINISH) {
            easyContactStore.setShowProfileAppbarButton(true);
        }
    }, [easyContactStore, step?.type]);

    useEffect(() => {
        runInAction(() => {
            easyContactStore.setCurrentStep(processId, stepId);
            uiStore.setBackgroundColor(ColorStyle(step?.type === STEP_TYPES.SELECT ? "white" : "background"));
            const { prevStep } = easyContactStore.stepNavigation;
            if (prevStep) {
                if (prevStep.type === STEP_TYPES.SELECT) {
                    const componentId = easyContactStore.getParentOfCurrentComonentId;
                    navStore.setBackbutton(
                        selectRoute(Route.selectComponent, {
                            processId,
                            stepType: String(STEP_TYPES.SELECT),
                            stepId: prevStep.id,
                            componentId: String(componentId)
                        }),
                        t("labels.goback")
                    );
                } else {
                    navStore.setBackbutton(
                        selectRoute(Route.step, {
                            processId,
                            stepType: String(prevStep.type),
                            stepId: prevStep.id
                        }),
                        t("labels.goback")
                    );
                }
            } else {
                navStore.setBackbutton(Route.start, t("labels.goback"));
            }
        });
        return () => {
            runInAction(() => {
                uiStore.setBackgroundColor(ColorStyle("background"));
            });
        };
    }, [navStore, processId, stepId, easyContactStore, uiStore, t, step]);

    const progression = easyContactStore.stepProgression;

    return (
        <>
            {!props.hideProcessProgress ? (
                <ProcessProgress currentStep={progression.currentStep} totalSteps={progression.totalSteps}>
                    {easyContactStore.stepNavigation.currentStepTitle}
                </ProcessProgress>
            ) : (
                <div style={{ height: 55 }} />
            )}
            {step?.step_mls[0].hint ? (
                <UI.Container className="pt-4">
                    <UI.Row>
                        <UI.Col
                            {...(step?.type === STEP_TYPES.SELECT && component?.type !== SELECT_COMPONENT_TYPES.OTHER
                                ? { md: { span: 8, offset: 2 }, className: "text-center" }
                                : { md: uiStore.defaultColumnSize.md, className: "text-left" })}
                        >
                            {step.step_mls.find((step) => step.language === getLang())?.hint}
                        </UI.Col>
                    </UI.Row>
                </UI.Container>
            ) : undefined}
            {props.children}
        </>
    );
};
